@if (showButtons) {
  <mat-card-actions class="user-action-btn activities-card" fxFlex>
    @if (isButtonDisplayedBySettings('previous') && showPreviousButton && ShowPrevNextBtns) {
      <button  class="h-32 btn-previous"
        (click)="onClick(UserActionButtonLabels.goBack)">
        {{ 'generic.previous' | translate }}
      </button>
    }
    @if (displayTestAnswer) {
      <button  class="h-52"
        (click)="onClick(UserActionButtonLabels.testAnswer)" [disabled]="!enabledUserActionButtons">
        {{ 'activities.lesson.test_answer' | translate }}
        <mat-icon class="ml-8" svgIcon="question_answer"></mat-icon>
      </button>
    }
    @if ((isShowSaveButton && !loading) || (displayRegister && !isShowSaveButton) || (displayRegistered && loading && !isShowSaveButton)) {
      <button
        class="h-52"
        (click)="onClick(UserActionButtonLabels.saveAnswer)" [disabled]="disableBtnRegister || loading">
        {{ 'generic.register' | translate }}
        @if ((disableBtnRegister && !displayRegistered) || !loading) {
          <mat-icon class="ml-8" svgIcon="save"></mat-icon>
        }
        @if ((!disableBtnRegister || displayRegistered) && loading) {
          <mat-spinner class="ml-8"></mat-spinner>
        }
      </button>
    }
    @if (isShowButtonPreviousInMulti && !loading) {
      <button id="previous-question-button"
        (click)="onClick(UserActionButtonLabels.launchPreviousActivity)">
        <mat-icon svgIcon="arrow_left_circle_outline"></mat-icon>
        <span>{{ 'activities.previous_question' | translate }}</span>
      </button>
    }
    @if (isShowButtonNextInMulti && !loading) {
      <button id="next-question-button"
        (click)="onClick(UserActionButtonLabels.launchNextActivity)">
        <mat-icon svgIcon="arrow_right_circle_outline"></mat-icon>
        <span>{{ multiTitleButton | translate }}</span>
      </button>
    }
    <!--TODO: Useless button ? and duplicate with button register line 13  -->
    @if (displayRegistered && !loading) {
      <button  class="h-52 registered" disabled>
        {{ 'generic.registered' | translate }}
        <mat-icon class="ml-8" svgIcon="save"></mat-icon>
      </button>
    }
    @if (displayReset) {
      <button  class="h-52"
        (click)="onClick(UserActionButtonLabels.resetAnswer)">
        {{ 'generic.reset' | translate }}
        <mat-icon class="ml-8" svgIcon="reset_answer"></mat-icon>
      </button>
    }
    @if (displayModify && !loading) {
      <button  class="h-52"
        (click)="onClick(UserActionButtonLabels.modifyAnswer)" [disabled]="loading">
        {{ 'generic.modify' | translate }}
        <mat-icon class="ml-8" svgIcon="visibility"></mat-icon>
      </button>
    }
    @if (displaySeeSolution) {
      <button  class="h-52"
        (click)="onClick(UserActionButtonLabels.seeSolution)" [disabled]="!disableBtnSeeSolution">
        {{ 'activities.lesson.see_solution' | translate }}
        <mat-icon class="ml-8" svgIcon="see_solution"></mat-icon>
      </button>
    }
    @if (displaySeeAnswer) {
      <button  class="h-52"
        (click)="onClick(UserActionButtonLabels.seeAnswer)">
        {{ 'activities.lesson.see_answer' | translate }}
        <mat-icon class="ml-8">spellcheck</mat-icon>
      </button>
    }
    @if (isButtonDisplayedBySettings('next') && ShowPrevNextBtns) {
      <button  class="h-32 btn-next"
        (click)="onClick(UserActionButtonLabels.gotoNext)">
        {{ 'generic.next' | translate }}
      </button>
    }
    @if (isNextLesson && isButtonDisplayedBySettings('nextLesson') && isLastStepInLesson) {
      <button  class="h-32"
        (click)="onClick(UserActionButtonLabels.gotoNextLesson)">
        {{ 'generic.nextLesson' | translate }}
      </button>
    }
    @if (allowErrorReporting()) {
      <app-error-reporting-trigger-button [type]="isMedia ? 'resource': 'exercise'" [activityId]="activityId"
        [objectTitle]="activityTitle"
      ></app-error-reporting-trigger-button>
    }
  </mat-card-actions>
}
